/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";

import So from "./cards/So";
import Balanslar from "./cards/Balanslar";
import Manbalar from "./cards/Manbalar";
import Chart7 from "../../components/Chart7";
import Chart4 from "../../components/Chart4";
import { header } from "../../../../components/api/Header";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

const Bdm = ({ date }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/dashboard/charts?date=" +
            date,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        setData({});
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  return (
    <div className='dashboard'>
      <div className='mgk-box and '>
        <Balanslar date={date} a={0} s={1} z={0} />
        <So date={date} />
      </div>

      {loading ? (
        <LoadingCard />
      ) : (
        <Manbalar date={date} singlerow={0} region='and' />
      )}

      {loading ? (
        <LoadingCard />
      ) : (
        <div className='jizz'>
          <div className='row'>
            <div className='col-md-6'>
              <Chart7 data={data["re"]} />
            </div>

            <div className='col-md-6'>
              <Chart4 data={data["t"]} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bdm;
